export const headerNavData = {
  blog: [
    {
      title: 'Top Stories and News',
      href: 'https://ackodrive.com/news/',
      icon: 'https://acko-cms.ackoassets.com/stories_And_News_e8546a4dc7.svg',
    },
    {
      title: 'Car and Bike reviews',
      href: 'https://ackodrive.com/reviews/',
      icon: 'https://acko-cms.ackoassets.com/nav_Reviews_6657d47452.svg',
    },
    {
      title: 'Interesting articles',
      href: 'https://ackodrive.com/articles/',
      icon: 'https://acko-cms.ackoassets.com/nav_Articles_f4219f4929.svg',
    },
  ],

  buyCar: [
    {
      title: 'New car',
      href: '/cars/',
      icon: 'https://acko-cms.ackoassets.com/nav_New_Car_36695e5d6b.svg',
      hasSubMenu: true,
    },
    {
      title: 'Express Delivery',
      href: '/collection/express-delivery-cars/',
      icon: 'https://acko-cms.ackoassets.com/nav_Express_Delivery_0e31df103a.svg',
    },
    {
      title: 'Electric Vehicles',
      href: '/collection/electric-cars/',
      icon: 'https://acko-cms.ackoassets.com/nav_Electric_Vehicle_ceb332babb.svg',
    },
  ],
}
